import React from "react";
import "./HeroBanner.css";
import { Link } from "react-router-dom";
import bannerVideo from "../assets/Home-Banner/hero-video.mp4";
import solarImg from "../assets/solar-thumbnail.png";

export default function HeroBanner() {
  return (
    <section className="cm-hero-section">

      {/* VIDEO BACKGROUND */}
      <video className="cm-hero-video" autoPlay muted loop playsInline>
    <source src={bannerVideo} type="video/mp4" />
  </video>

      {/* DARK OVERLAY */}
      <div className="cm-hero-overlay">
        
        {/* LEFT CONTENT */}
        <div className="cm-hero-content">
          <span className="cm-hero-subtitle">CM GROUP</span>

          <h1 className="cm-hero-title">
            Integrated Success. <br />
            Built for the Future.
          </h1>

          <div className="cm-hero-buttons">
  <Link to="/about" className="cm-hero-btn-primary">
    👍 Discover more
  </Link>

  <Link to="/green-energy/services" className="cm-hero-btn-secondary">
    👁 View services
  </Link>
</div>
        </div>
      

        {/* <div className="cm-hero-right-card">
          <img src={solarImg} className="cm-hero-right-img" alt="Solar" />

          <div className="cm-hero-right-text">
            <h3>
              We are providing awesome <br />
              <strong>20+ green energy services.</strong>
            </h3>

            <div className="cm-hero-input-box">
              <input type="text" placeholder="Enter your phone number" />
              <button>→</button>
            </div>

            <p className="cm-hero-small-note">
              *You agree to green energy terms of service.
            </p>
          </div>
        </div> */}

      </div>
    </section>
  );
}
